import { render } from "./Success.vue?vue&type=template&id=09af1864"
const script = {}

import "./Success.vue?vue&type=style&index=0&id=09af1864&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__